import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { setBreadcrumb } from '../actions/breadcrumb'

import { isEmpty } from '../assets/utils'

import Contact from './Contact';

class SummaryCustomer extends React.Component {

  render() {
    if (!isEmpty(this.props.customer)) {
      return (
        <div>
          <h2 className="mt-4">{I18n.t('layouts.summary.title')}</h2>
          <Contact />
        </div>
      )
    } else {
      return (<div></div>)
    }
  }
}

const mapStateToProps = state => ({
   customer: state.customer,
})

const mapDispatchToProps = dispatch => bindActionCreators({ setBreadcrumb }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(SummaryCustomer)


// WEBPACK FOOTER //
// ./app/javascript/components/components/SummaryCustomer.jsx